export default __webpack_public_path__ + "static/media/Inventory-green.6c73f5da.svg";